// extracted by mini-css-extract-plugin
export default {"image":"styles_image__YUARg","content":"styles_content__rQXSm","content2":"styles_content2__ovRgq","content3":"styles_content3__3wwdU","more":"styles_more__XT5tU"};